import { useDispatch } from 'react-redux';

import { CART_SHIPPING_MODEL_VIEW } from 'core/domains';
import { user, cart } from 'core';
import { useShippingModelSelector } from 'core/use-cases/user/selectors';
import { onClickByStep } from '../helpers';

export const useShippingModel = () => {
  const dispatch = useDispatch();
  const { setShippingModel, setShippingModelStep } = cart.commands.useCartCommand();
  const { cleanSearchInput } = user.commands.useUserCommand();

  const { toggleActive, data: newShippingModelData } = useShippingModelSelector();
  const { shippingModel: selectedShippingModel, shippingModelType = '' } =
    cart.hooks.useCartShippingModel();

  const step = cart.hooks.useCartPropertyByKey('step');

  const {
    data: { shippingModel },
  } = user.hooks.useUser();

  const findShippingModelAddress = (distributionCenterCode?: number) => {
    if (!newShippingModelData.default.code) {
      return;
    }
    return [
      ...(newShippingModelData.availables.length
        ? newShippingModelData.availables[0].deliveries
        : []),
      newShippingModelData.default.delivery,
    ].find((delivery) => {
      return delivery.distributionCenterCode === distributionCenterCode;
    })?.address;
  };

  const handleClick = () => {
    const shippingModelAddress = toggleActive
      ? findShippingModelAddress(selectedShippingModel.distributionCenterCode)
      : undefined;

    onClickByStep(
      step as string,
      selectedShippingModel,
      shippingModelType,
      toggleActive,
      dispatch,
      {
        setShippingModel,
        setShippingModelStep,
      },
      shippingModelAddress,
    );
  };

  const handleOpen = () => {
    cleanSearchInput();
    setShippingModelStep({
      step: CART_SHIPPING_MODEL_VIEW.OPTIONS,
      defaultDistributionCenterCode: shippingModel?.default?.delivery?.distributionCenterCode,
      defaultShippingModelCode: shippingModel?.default?.code,
    });
  };

  const handleClose = () => {
    dispatch({ type: 'toggleShipping', payload: false });

    setShippingModelStep({ step: CART_SHIPPING_MODEL_VIEW.OPTIONS });
  };

  return {
    handleClose,
    handleClick,
    handleOpen,
    shippingModel,
  };
};
